
import Vue from 'vue';
import { CvGrid, CvRow, CvColumn, CvButton, CvButtonSet } from '@carbon/vue';

export default Vue.extend({
  name: 'QuestionAboutWhite',
  components: {
    CvGrid,
    CvRow,
    CvColumn,
    CvButton,
    CvButtonSet,
  },
});
